import React, { useState, Fragment } from 'react';
import { Drawer } from 'antd';
import { NavLink } from 'react-router-dom';
import { PAGES, usePermissions } from 'hooks/permissions/permissions';

/**
 * Reports sub-navigation.
 *
 * Declared once and rendered into both the desktop bar and the mobile drawer.
 * They were previously written out twice and had already drifted -- the same
 * route read "Employee" on desktop and "Search Employee" on mobile.
 *
 * "Today's Attendance" and "Today's Absentees" were merged into one Daily
 * Attendance screen with a Present/Absent toggle: they called the same endpoint
 * with a different type flag, and neither was limited to today.
 *
 * Every report is gated by the single Report VIEW permission.
 */
export const REPORT_LINKS = [
    { to: '/reports/manpower-trend', label: 'Manpower Trend', page: PAGES.REPORT },
    { to: '/reports/contractor-manpower', label: 'Contractor Manpower', page: PAGES.REPORT },
    { to: '/reports/monthly-attendance', label: 'Monthly Attendance', page: PAGES.REPORT },
    { to: '/reports/daily-attendance', label: 'Daily Attendance', page: PAGES.REPORT },
    { to: '/reports/first-in-last-out', label: 'First In / Last Out', page: PAGES.REPORT },
    { to: '/reports/search-employee', label: 'Employee Search', page: PAGES.REPORT },
];

const ReportHeader = () => {
    const [open, setOpen] = useState(false);

    const showDrawer = () => setOpen(true);
    const onClose = () => setOpen(false);

    const { can } = usePermissions();

    const visibleLinks = REPORT_LINKS.filter((link) => can(link.page));

    return (
        <Fragment>
            <header className="jr-view-header view-header">
                <div className="web-links">
                    {visibleLinks.map((link) => (
                        <NavLink key={link.to} to={link.to}>{link.label}</NavLink>
                    ))}
                </div>
                <div className="mobile-view-only">
                    <h1 onClick={showDrawer}>Menu</h1>
                    <Drawer className='dra' placement="right" onClose={onClose} open={open}>
                        <ul>
                            {visibleLinks.map((link) => (
                                <li key={link.to}>
                                    <NavLink onClick={onClose} to={link.to}>{link.label}</NavLink>
                                </li>
                            ))}
                        </ul>
                    </Drawer>
                </div>
            </header>
        </Fragment>
    );
};

export default ReportHeader;
